import { Chip } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';

type StandingOrderStatus = 'ACTIVATED' | 'SUSPENDED' | 'TERMINATED';

export function StandingOrderStatusBadge({ status }: { status: StandingOrderStatus }) {
  const { t } = useTranslation();

  const getStatusColor = (status: StandingOrderStatus) => {
    switch (status) {
      case 'ACTIVATED':
        return 'success';
      case 'SUSPENDED':
        return 'warning';
      case 'TERMINATED':
        return 'error';
      default:
        return 'default';
    }
  };

  const getStatusLabel = (status: StandingOrderStatus) => {
    switch (status) {
      case 'ACTIVATED':
        return t('Active');
      case 'SUSPENDED':
        return t('Suspended');
      case 'TERMINATED':
        return t('Terminated');
      default:
        return status;
    }
  };

  return (
    <Chip
      label={getStatusLabel(status)}
      color={getStatusColor(status)}
      size="small"
      variant="filled"
    />
  );
}
